export default __webpack_public_path__ + "static/tpx_s_white-f41df36a6214c2d15b9d6e9e86dfce34.png";